<template>
  <div class="pdf" >
      <span style="float: right">
        <el-switch
            v-if="checkStatus ==1 || checkStatus ==2 "
            :width="50"
            class="mr10 fl"
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value=2
            :inactive-value=1
            @change="checkPass(checkStatus)"
        >
        </el-switch>
        <el-switch
            v-if="checkStatus ==3 || checkStatus ==4 "
            :width="50"
            class="mr10 fl"
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value=4
            :inactive-value=3
            @change="checkPass(checkStatus)"
        >
        </el-switch>
        <el-switch
            v-if="checkStatus ==0"
            :width="50"
            class="mr10 fl"
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value=2
            :inactive-value=0
            @change="checkPass(checkStatus)"
        >
        </el-switch>
        <el-button v-if="checkStatus == 1" class="" type="text" style="padding: 0; margin-bottom: 10px" >
                <el-tooltip class="item" effect="dark" :content="checkResult | result" placement="top">
                  <span>原因</span>
                </el-tooltip>
        </el-button>
      </span>
    <pdf :src="pdfsrc"
         :page="currentPage"
         class="pdf1"
         style="display: inline-block"
         @num-pages="pageCount=$event"
         @page-loaded="currentPage=$event"
         @loaded="loadPdfHandler"
    ></pdf>
    <p class="arrow font14px" style="text-align: center">
      <span @click="changePdfPage(0)" class="turn" style="cursor: pointer" :class="{grey: currentPage==1}">上一页</span>
      {{currentPage}} / {{pageCount}}
      <span @click="changePdfPage(1)" class="turn" style="cursor: pointer" :class="{grey: currentPage==pageCount}">下一页</span>

    </p>
  </div>
</template>

<script>

  import https from '@/https.js'
  import pdf from 'vue-pdf'


  export default {
    name: "",
    components: {
      pdf: pdf
    },
    props: ['courseId', 'catalogId','resourceId', 'isNextStep'],
    data() {
      return {
        total:100,
        tableData: [],
        viewVisible: false,
        pdfsrc: "",
        checkStatus: '',
        checkResult: '',
        currentPage: 1,
        pageCount: 0,
        checkResult: '',
      }
    },
    methods: {
      loadPdfHandler() {

      },
      changePdfPage (val) {
        // console.log(val)
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
          // console.log(this.currentPage)
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
          // console.log(this.currentPage)
        }
      },
      closeDialog() {
        this.viewVisible = false;
      },
      uploadMaterial(row) {
        let params = {
          fileUrl: row.filePath,
          fileName: row.fileName
        }
        https.fetchPost("/question/filePreview" ,params,"","","blob" ).then((data) => {
          this.viewVisible = true;
          let file = window.URL.createObjectURL(data.data);
          this.pdfsrc = file;
          
        }).catch(err=>{
              console.log(err)
            }
        )

      },
      checkPass(checkStatus) {

        if(checkStatus == 1) {
          this.checkStatus = 3;
        }

        if(checkStatus == 2) {
          this.checkStatus = 4;
        }

        let params = { // 0 目录 1资源
          courseId: this.courseId,
          resourceId: this.resourceId,
          resourceType: 1,
          checkStatus: this.checkStatus
        };
        https.fetchPost('/courseCheck/checkPass',params ,"json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '加载失败'+msg
            });
          }
        }).catch(err=>{
              console.log(err)
            }
        )
      },
      getResource() {
        let params = {
          "catalogId":this.catalogId
        }
        https.fetchPost('/resources/get', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.uploadMaterial(data.data.data.data);
            this.checkStatus = data.data.data.checkStatus;
            this.checkResult = data.data.data.checkResult;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
    },
    filters: {
      result(val) {
        return "文档内容"+val;
      }
    },
    created: function () {
      this.getResource();
      if(this.pdfsrc) {
        this.pdfsrc = pdf.createLoadingTask(this.pdfsrc);
      }
    }
  };
</script>

<style scoped>
  
  .pdf1 {
  width: 100%;
    margin-top: 10px;
}
</style>